import React from 'react';


class ResultCard extends React.Component {
    render() {
        const coleta = this.props.coleta;

        return (<React.Fragment>
                <div className="card-body" style={{border: '1px solid #ccc', marginBottom: '10px'}}>
                    <div className="d-flex justify-content-center ">

                        <div style={{
                            width: '40%',
                            margin: '10px',
                            borderRadius: '5px',
                            padding: '20px',
                            backgroundImage: `url(${coleta.image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',


                        }}>

                        </div>

                        <div style={{
                            width: '60%',
                            margin: '10px',
                            borderRadius: '5px',
                            padding: '20px',
                            backgroundColor: '#D3D3D3'
                        }}>
                            <h5 className="card-title" style={{marginBottom: '25px'}}>
                                <button className="btn btn-link btn-sm" onClick={(e)=>{
                                    e.preventDefault();
                                    this.props.openBuscaEmpreendimentoComFiltros({
                                        nome: coleta.title,
                                        nome_cidade: [coleta.city],
                                        estado: [coleta.state],
                                    })
                                }}> { coleta.title} &nbsp; <i className="fa fa-link"></i> </button>
                                { coleta.ignorado && <span className="badge badge-danger">Ignorado</span>} &nbsp;
                                { !coleta.ignorado && <span className="badge badge-success">Novo</span>} &nbsp;
                                { coleta.possible_new_launch && <span className="badge badge-info">Possível Lançamento</span>}
                            </h5>

                            {coleta.possible_match_id && <>
                                <div className="alert alert-warning" role="alert">
                                    <i className="fa fa-exclamation-triangle"></i>
                                    &nbsp; Possível Empreendimento Cadastrado: <strong><a target="_blank"
                                                                                          className="alert-link"
                                                                                          href={coleta.possible_match_url}>{coleta.possible_match_name}</a>
                                </strong>
                                </div>
                            </>}

                            {coleta.building_registered_id && <>
                                <div className="alert alert-success" role="alert">
                                    <i className="fa fa-exclamation-triangle"></i>
                                    &nbsp; Dados usados para cadastrar o empreendimento: <strong><a target="_blank"
                                                                                          className="alert-link"
                                                                                          href={route('building.edit', coleta.building_registered_id )}>{coleta.building_registered_name}</a> &nbsp;
                                </strong>
                                    na data de <strong>{coleta.building_registered_at_formatted}</strong> por <strong>{coleta.building_registered_by_user_name}</strong>
                                </div>
                            </>}

                            {coleta.size && <p>
                                <i className="fa-solid fa-ruler-combined"></i> {coleta.size}
                            </p>}
                            {coleta.status && <p>
                                <strong>Status:</strong> {coleta.status}
                            </p>}

                            <div style={{maxHeight: '140px', overflowY: 'auto'}}>
                                <p className="card-text">{coleta.description}</p>
                                <p className="card-text">{coleta.features}</p>
                            </div>
                            <hr/>

                            <p className="card-text"><strong>Cidade:</strong> {coleta.city}</p>
                            <p className="card-text"><strong>Estado:</strong> {coleta.state}</p>
                            <p className="card-text"><strong>Bairro:</strong> {coleta.neighborhood}</p>
                            <p className="card-text"><strong>Telefone:</strong> {coleta.contact_info}</p>
                            <a href={coleta.link} className="btn-link" target="_blank"
                               rel="noopener noreferrer">
                                <i className="fa fa-link"></i> {coleta.link}
                            </a>

                            {coleta.ignorado && <>
                                <div className="alert alert-danger" role="alert" style={{marginTop: '15px'}}>
                                    Coleta Ignorada na data de <strong> {coleta.ignored_at_formatted}</strong> por <strong>{coleta.ignored_by_user_name}</strong> pelo motivo <strong>{coleta.ignored_reason}</strong>
                                    <br />
                                </div>
                            </>}

                            <div className="d-flex small muted mt-3">
                                <div>
                                    <i className="fa fa-clock"></i> <strong>Criado Em:</strong> {coleta.created_at_formatted}<br />
                                </div>
                                <div>
                                    <i className="fa fa-clock"></i> <strong>Atualizado Em:</strong> {coleta.updated_at_formatted}<br />
                                </div>
                            </div>


                            <hr/>

                            {!coleta.ignorado && <>
                                <button className="btn btn-danger btn-sm" onClick={(e) => {
                                    e.preventDefault();
                                    this.props.showModalIgnorarColeta( coleta );
                                }}>
                                    <i className="fa fa-ban"></i> Ignorar
                                </button>

                            </>}

                            &nbsp;

                            <button className="btn btn-success btn-sm" onClick={(e) => {
                                e.preventDefault();

                                const coletaPayload = {
                                    ...coleta, site_id: coleta.mapeamento_link_id, site_url: coleta.mapeamento_link
                                }

                                this.props.cadastrarEmpreendimento(coletaPayload)
                            }}>
                                <i className="fa-solid fa-building-circle-arrow-right"></i> Adicionar
                                Empreendimento
                            </button>


                        </div>
                    </div>
                </div>
            </React.Fragment>)
    }
}

export default ResultCard;
